namespace app{
	export class Const{
		static DATE_DEFAULT:string = "M月D日";
		static DATE_CHOSEKI:string = "YYYYMMDD";
		static DATE_PINPOINT_BASE:string = "YYYYMMDDHHMMSS";
		static DATE_PINPOINT_ITEM:string = "YYYYMMDDHHMM";
		static DATE_PINPOINT_CREATION:string = "YYYY年MM月DD日　HH時";
		static DATE_WEEKLY_CREATION:string = "XXXXXXXXXX";
		static DATE_WEEKLY: string = "MM/DD";
		static TIME_DEFAULT: string = "HH時HH分";
		static DATE_WARN: string = "02月16日14時06分発表";
	}
}

